// Lightweight funnel-event helper. Fires to GA4 (gtag) and Meta Pixel (fbq) if present.
export const track = (event, params = {}) => {
  try {
    if (typeof window === 'undefined') return;
    if (window.gtag) window.gtag('event', event, params);
    if (window.fbq) window.fbq('trackCustom', event, params);
  } catch (e) {
    /* analytics must never break the app */
  }
};

const ADS_ID = 'AW-394266571';
const adsConversion = (label, params) => {
  if (label && window.gtag) window.gtag('event', 'conversion', { send_to: `${ADS_ID}/${label}`, ...params });
};
const pushDataLayer = (payload) => {
  window.dataLayer = window.dataLayer || [];
  if (payload.ecommerce) window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(payload);
};

// Contact enquiry: GA4 generate_lead (via GTM dataLayer), Google Ads lead conversion, Meta Lead.
export const trackLead = (formName) => {
  try {
    pushDataLayer({ event: 'generate_lead', form_name: formName });
    adsConversion(process.env.REACT_APP_GADS_LEAD_LABEL);
    if (window.fbq) window.fbq('track', 'Lead', { content_name: formName });
  } catch (e) { /* analytics must never break the app */ }
};

// Academy sale: fires once per transaction. GA4 purchase (dataLayer), Google Ads purchase conversion, Meta Purchase.
export const trackPurchase = ({ transactionId, value, currency, itemId, itemName, category }) => {
  try {
    const key = `bc_purchase_tracked_${transactionId}`;
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, '1');
    pushDataLayer({
      event: 'purchase',
      ecommerce: { transaction_id: transactionId, value, currency, items: [{ item_id: itemId, item_name: itemName, item_category: category, price: value, quantity: 1 }] },
    });
    adsConversion(process.env.REACT_APP_GADS_PURCHASE_LABEL, { value, currency, transaction_id: transactionId });
    whenFbq(() => window.fbq('track', 'Purchase', { value, currency, content_name: itemName, content_ids: [itemId], content_type: 'product' }, { eventID: transactionId }));
  } catch (e) { /* analytics must never break the app */ }
};

// Pixel loads after window 'load'; wait for it (up to 20s) instead of dropping the event.
const whenFbq = (fire, tries = 0) => {
  if (window.fbq) { fire(); return; }
  if (tries < 66) setTimeout(() => whenFbq(fire, tries + 1), 300);
};
